<mat-card>
  <mat-card-header class="task-detail-header">
    <mat-card-title>Task</mat-card-title>
    <mat-chip-list class="small-mat-chip" *ngIf="taskForm?.get('priority')?.value">
      <ng-container [ngSwitch]="taskForm.get('priority').value">
        <mat-chip *ngSwitchCase="'high'" color="warn" selected>High</mat-chip>
        <mat-chip *ngSwitchCase="'medium'" color="accent" selected>Medium</mat-chip>
        <mat-chip *ngSwitchCase="'low'" color="default" selected>Low</mat-chip>
        <mat-chip *ngSwitchDefault color="default">Low</mat-chip>
      </ng-container>
    </mat-chip-list>
    <button
      mat-icon-button
      type="button"
      class="task-detail-close"
      aria-label="Close task detail"
      matTooltip="Close"
      (click)="cancel()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content>
    <form class="task-form" [formGroup]="taskForm" (ngSubmit)="saveTask()">
      <div class="task-form-row">
        <app-search-patient-autocomplete
          class="task-form-field"
          [searchModel]="searchModel"
          [searchInput]="taskForm.get('patient')"
        ></app-search-patient-autocomplete>
      </div>
      <mat-form-field class="patient-list-filter-select">
        <mat-label>Task owner</mat-label>
        <mat-select formControlName="task_owner">
          <mat-option *ngFor="let provider of providers" [value]="provider.user_id">
            {{ provider.lastName }}, {{ provider.firstName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Follow-up date</mat-label>
        <input matInput formControlName="due_date" [matDatepicker]="picker" placeholder="Follow-up date" />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker"
          [disabled]="taskForm.get('due_date')?.disabled"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker [disabled]="taskForm.get('due_date')?.disabled"></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Task</mat-label>
        <textarea matInput formControlName="task_name" placeholder="Task name" rows="5"></textarea>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" placeholder="Task description" rows="5"></textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Category</mat-label>
        <mat-select formControlName="category">
          <mat-option *ngFor="let category of categories" [value]="category">
            {{ category }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="taskForm.get('category')?.value === 'OTHER'">
        <input matInput formControlName="other_category" placeholder="Other:" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Priority</mat-label>
        <mat-select formControlName="priority">
          <mat-option *ngFor="let priority of priorities" [value]="priority.value">
            {{ priority.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <ng-container *ngIf="!task?.id && !isAcuityReviewTask">
        <mat-slide-toggle color="primary" labelPosition="before" formControlName="pinned">
          Pin task
        </mat-slide-toggle>
      </ng-container>
      <ng-container *ngIf="!isAcuityReviewTask">
        <mat-slide-toggle color="primary" labelPosition="before" formControlName="completed"
          >Is completed?
        </mat-slide-toggle>
      </ng-container>
      <ng-container *ngIf="isAcuityReviewTask && !task?.completed">
        <mat-form-field appearance="outline">
          <mat-label>Review Notes</mat-label>
          <textarea
            matInput
            formControlName="reviewNotes"
            placeholder="Add notes about your review decision"
            rows="3"
          ></textarea>
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="isApcmTransitionTask && !task?.completed">
        <mat-form-field appearance="outline">
          <mat-label>APCM Tier</mat-label>
          <mat-select formControlName="selectedApcmTier">
            <mat-option *ngFor="let tier of apcmTiers" [value]="tier.value">{{ tier.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="isApcmTransitionTask && task?.completed && task?.review_action === 'approve'">
        <mat-form-field appearance="outline">
          <mat-label>APCM Tier</mat-label>
          <input matInput [value]="task?.apcm_tier || ''" disabled />
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="isAcuityReviewTask && task?.completed">
        <mat-form-field appearance="outline">
          <mat-label>Review Notes</mat-label>
          <textarea matInput [value]="task?.review_notes || ''" rows="3" disabled></textarea>
        </mat-form-field>
      </ng-container>
      <div *ngIf="lastUpdatedBy && !isAcuityReviewTask" class="task-form-text">
        Last updated by: {{ lastUpdatedBy }}
      </div>
      <div fxFlex fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="10px">
        <button mat-button type="button" (click)="cancel()">Cancel</button>
        <ng-container *ngIf="!isAcuityReviewTask">
          <button mat-raised-button color="primary" [disabled]="taskForm.invalid" type="submit" cdkFocusInitial>
            Save
          </button>
        </ng-container>
        <ng-container *ngIf="isAcuityReviewTask && !task?.completed">
          <button
            mat-raised-button
            type="button"
            class="acuity-reject-btn"
            (click)="rejectReview()"
            [disabled]="resolvingAction !== null"
          >
            <mat-spinner *ngIf="resolvingAction === 'reject'" [diameter]="20"></mat-spinner>
            <span *ngIf="resolvingAction !== 'reject'">Reject</span>
          </button>
          <button
            mat-raised-button
            color="primary"
            type="button"
            class="deescalation-approve-btn"
            (click)="approveReview()"
            [disabled]="resolvingAction !== null"
            cdkFocusInitial
          >
            <mat-spinner *ngIf="resolvingAction === 'approve'" [diameter]="20"></mat-spinner>
            <span *ngIf="resolvingAction !== 'approve'">Approve</span>
          </button>
        </ng-container>
      </div>
      <ng-container *ngIf="isMonthlyJourneyTask">
        <button mat-raised-button color="primary" type="button" (click)="openCareCallGuide()">
          <mat-icon>menu_book</mat-icon>
          View Care Call Guide
        </button>
      </ng-container>
    </form>
  </mat-card-content>
</mat-card>
